import script from "./MainNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNavBar.vue?vue&type=script&setup=true&lang=js"

import "./MainNavBar.vue?vue&type=style&index=0&id=fd5e11d8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd5e11d8"]])

export default __exports__